module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/desktop-500_4d12cc.jpg";